import * as React from 'react';
import PropTypes from 'prop-types';

import MapPreview from './MapPreview';

/**
 * A React component for displaying a map selection tool, complete with map preview
 * Note: Map preview is a convenient work-around for pre-loading the map SVGs into the DOM!
 * Uses Bulma's https://bulma.io/documentation/components/navbar/
 *
 * @class MapSelector
 * @extends {React.Component}
 */
class MapSelector extends React.Component {
    constructor (props) {
        super(props);

        // Track whether the menu is displayed
        this.state = {
            menuOpen: false
        };

        // Bind onClick
        this.toggleMenuOpen = this.toggleMenuOpen.bind(this);
    }

    render () {
		const { availableMaps, selectedMap, setSelectedMap } = this.props;
		// Generate navigation tabs for each available map

		// const navItems = availableMaps.sort().map((availableMap) => {
    const navItems = availableMaps.map((availableMap) => {
			let isSelected = "";
      if (selectedMap) {
        if (availableMap.id === selectedMap.id) {
          isSelected = " is-active";
        } else {
          isSelected = "";
        }
      }
			const mapPreview = (
				<MapPreview
					mapName = {availableMap.id}
				/>
			);

			return (
				<a
				// Keep the items from expanding too big
				// TODO: Base on # of items displayed
					style={{maxWidth: "200px", transform: "rotate3d(6,-2,5,70deg)", maxHeight: "177px", bottom: availableMap.level * 180 + 1180, position: "absolute"}}
					className={"navbar-item" + isSelected}
					key={availableMap.id}
					onClick={() => {
						setSelectedMap(availableMap);
						this.toggleMenuOpen();
					}}
				>
					<article className="message is-medium no-select">

						<div className="message-header">
							{ "Floor " + availableMap.level }
						</div>
						<div className="message-body">
							{ mapPreview }
						</div>
					</article>
				</a>
			);
		});

		return (
			<nav className="navbar is-fixed-bottom" style={{left: 70, bottom: 30, maxWidth: 280}}>
				{/* <div className="container"> */}
					<div className="navbar-brand">
						<a className="navbar-item">
						{/* <img src="./l11logo.png" alt="Logo" /> */}
						</a>
						<span className="navbar-burger burger" onClick={this.toggleMenuOpen}>
						<span />
						<span />
						<span />
						</span>
					</div>
					<div className={'navbar-menu ' + (this.state.menuOpen ? 'is-active' : '')}>
						<div className="navbar-begin">
							{navItems}
						</div>
					</div>
				{/* </div> */}
			</nav>
		);
	}

    // Toggle menu visibility
    toggleMenuOpen () {
        this.setState({
            menuOpen: !this.state.menuOpen
        });
    }
}

MapSelector.propTypes = {
	availableMaps: PropTypes.arrayOf(PropTypes.object).isRequired,
    setSelectedMap: PropTypes.func.isRequired,
	selectedMap: PropTypes.object,
};

export default MapSelector;



// WEBPACK FOOTER //
// ./src/components/MapSelector.js